<template>
  <div v-if="isLoading">
    <loading />
  </div>
  <div v-else class="p-10">
    <excelExport @exportexcel="getExcel()" />
    <table class="font-thin text-gray-700 text-sm table-auto">
      <thead class="font-black text-left">
        <tr>
          <td>
            <div class="page-header-space"></div>
          </td>
        </tr>
        <tr>
          <td colspan="7">
            <h1>
              Listado de estado de comisiones
            </h1>
          </td>
        </tr>
        <tr>
          <td class="w-5/12">Marca</td>
          <td class="w-1/12">Año</td>
          <td class="w-2/12">Temporada</td>
          <td class="w-1/12">Comisión prevista</td>
          <td class="w-1/12">Comisión facturada</td>
          <td class="w-1/12">Diferencia</td>
          <td class="w-1/12">Pendiente pago</td>
        </tr>
      </thead>
      <tr
        v-for="fabricante in report.fabricantes"
        :key="fabricante.nombreFbaricante"
      >
        <td colspan="7" class="bloque leading-none">
          <table class="border-2 border-gray-800 font-semibold">
            <tr>
              <td colspan="3" class="w-8/12">
                {{ fabricante.nombreFabricante }}
              </td>
              <td class="w-1/12 text-right">
                {{ fabricante.totalFabricanteComisionPrevista }}
              </td>
              <td class="w-1/12 text-right">
                {{ fabricante.totalFabricanteComisionFacturada }}
              </td>
              <td class="w-1/12 text-right">
                {{ fabricante.totalFabricanteDiferencia }}
              </td>
              <td class="w-1/12 text-right">
                {{ fabricante.totalFabricantePendientePago }}
              </td>
            </tr>
          </table>
          <table class="mb-2 leading-1 print:leading-3">
            <tr class="border-b-2 pt-2" v-for="marca in fabricante.marcas" :key="marca.idMarca">
              <td class="w-5/12 p-1">
                {{ marca.descripcionMarca }}
              </td>
              <td class="w-1/12 p-1">
                {{ marca.anyo }}
              </td>
              <td class="w-2/12 p-1">
                {{ marca.tipoTemporada }}
              </td>
              <td class="w-1/12 p-1 text-right">
                {{ marca.importeComisionPrevista }}
              </td>
              <td class="w-1/12 p-1 text-right">
                {{ marca.importeComisionFacturada }}
              </td>
              <td class="w-1/12 p-1 text-right">
                {{ marca.importeDiferencia }}
              </td>
              <td class="w-1/12 p-1 text-right">
                {{ marca.importePendientePago }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="border-t border-gray-800">
        <td colspan="3" class="w-8/12 p-1">
          TOTAL GENERAL
        </td>
        <td class="w-1/12 p-1 font-semibold text-right">
          {{ report.totalGeneralComisionPrevista }}
        </td>
         <td class="w-1/12 p-1 font-semibold text-right">
          {{ report.totalGeneralComisionFacturada }}
        </td>
         <td class="w-1/12 p-1 font-semibold text-right">
          {{ report.totalGeneralDiferencia }}
        </td>
         <td class="w-1/12 p-1 font-semibold text-right">
          {{ report.totalGeneralPendientePago }}
        </td>
      </tr>
      <tfoot>
        <tr>
          <td>
            <div class="page-footer-space"></div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <footerPage></footerPage>
  <div class="header p-10">
    <table>
      <tr>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { ExpedicionesEstadoComisiones } from "@/types/reports/expediciones/expedicionesEstadoComisiones/ExpedicionesEstadoComisiones";
import { ExpedicionFilter } from "@/types/expediciones/ExpedicionView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<ExpedicionesEstadoComisiones> = ref({
      totalGeneralComisionPrevista: "",
      totalGeneralComisionFacturada: "",
      totalGeneralDiferencia: "",
      totalGeneralPendientePago: "",
      fabricantes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("expedicionFilter");
      let filter = {} as ExpedicionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportExpedicionEstadoComisionesDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("expedicionFilter");
      let filter = {} as ExpedicionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportExpedicionEstadoComisionesDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
</script>
<style scoped>
table {
  width: 100%;
}

table table {
  text-align: left;
}

thead td {
  text-align: center;
}

.bloque {
  page-break-inside: avoid;
}

.header {
  font-size: 9px;
  line-height: 10px;
  position: fixed;
  top: 0;
  visibility: hidden;
  counter-increment: page;
}

@media print {
  table {
    font-size: 10px;
  }
  td {
    line-height: 0.75rem;
  }
  @page {
    size: landscape;
  }

  .header {
    visibility: visible;
  }

  .page-footer-space {
    height: 20px;
  }

  .page-header-space {
    height: 0px;
  }
}
</style>